import {
  Component,
  Inject,
  OnInit,
  HostListener,
  ElementRef,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Candidate } from 'src/app/interfaces/Candidate';
import { environment } from 'src/environments/environment.prod';
import { DocuViewerComponent } from '../docu-viewer/docu-viewer.component';
import { PuzzleService } from 'src/app/services/puzzle.service';
import { TranslateService } from '@ngx-translate/core';
import { ResponseDialogComponent } from '../response-dialog/response-dialog.component';
import { io, Socket } from 'socket.io-client';
import { LocalService } from 'src/app/services/local.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { APIResponse } from 'src/app/interfaces/response';
import { UploadCvComponent } from '../upload-cv/upload-cv.component';

@Component({
  selector: 'app-wsp-chat',
  templateUrl: './wsp-chat.component.html',
  styleUrls: ['./wsp-chat.component.css'],
})
export class WspChatComponent implements OnInit, OnDestroy {
  userImage;
  candidate: Candidate;
  showEmojiPicker = false;
  commonEmojis = [];
  messageList = [];
  currentPage = 1;
  pageSize = 20;
  isLoadingMoreMessages: boolean = false;
  totalMessages: number = 0;
  totalPages: number = 0;
  audioPlayers: { [key: string]: HTMLAudioElement } = {};
  audioProgress: { [key: string]: number } = {};
  audioDurations: { [key: string]: string } = {};
  audioCurrentTime: { [key: string]: string } = {};
  audioLoaded: { [key: string]: boolean } = {};
  @ViewChild('emojiButton') emojiButton: any;
  @ViewChild('emojiPanel') emojiPanel: ElementRef;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  cvLogo: SafeResourceUrl = '../../../assets/icons/cv-icon.svg';
  nocvLogo: SafeResourceUrl = '../../../assets/icons/noCV-icon.svg';
  whatsIcon: SafeResourceUrl = '../../assets/icons/whatsapp.png';
  defaultpfp: SafeResourceUrl = '../../../assets/icons/default-pfp-icon.svg';
  private readonly BAR_COUNT = 40; // Número de barras en la visualización
  private wavePattern: number[] = [];
  selectedFile: File | null = null;
  selectedFileName: string | null = null;
  selectedFileType: string | null = null;
  selectedFileUrl: string | null = null;
  @ViewChild('imageFileInput') imageFileInput: ElementRef;
  @ViewChild('pdfFileInput') pdfFileInput: ElementRef;
  message: string = '';
  conversationId: string;
  candidateNumber: string;
  messageTemplates: any[] = [];
  blockedInput: boolean = false;
  templatesActive: boolean = false;
  showChatHistory: boolean = false;
  blockedReason: string = 'blockedWspBusy';
  socketTries: number = 0;
  whatsappNumberId: string = environment.whatsappNumberId;
  sendingMessage: boolean = false;
  userPermissions: string[];
  isMini: boolean = false;
  showCVClient: boolean = false;

  private readonly permittedExtensions = ['.jpg', '.jpeg', '.png', '.pdf'];
  private readonly maxFileSize = 5 * 1024 * 1024; // 5MB
  private socket: Socket;

  constructor(
    private dialogRef: MatDialogRef<WspChatComponent>,
    @Inject(MAT_DIALOG_DATA) { data },
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private puzzleService: PuzzleService,
    private translate: TranslateService,
    private localService: LocalService,
  ) {
    this.candidate = data;

    if (this.candidate?.cdT_PHONE_NUMBER_ONE) {
      this.candidateNumber = this.candidate?.cdT_PHONE_NUMBER_ONE;
    }

    if (data?.candidateImageInfo?.rpC_IMG_ROUTE) {
      this.userImage = this.sanitizer.bypassSecurityTrustResourceUrl(
        environment.imageUrl + data.candidateImageInfo?.rpC_IMG_ROUTE,
      );
    }

    if (this.candidate?.whatsapP_CONVERSATION_INFO?.conV_ID) {
      this.conversationId = this.candidate?.whatsapP_CONVERSATION_INFO?.conV_ID;
      this.continueConversation();
    } else {
      this.newConversation();
    }

    const tokencito = this.localService.getJsonValue('token');
    this.userPermissions = tokencito.data.permissions.map(
      (permission) => permission.code,
    );
    this.isMini = tokencito.data.isMiniCompany;
    this.showCVClient = tokencito.data?.companyCvClient;
  }

  ngOnInit(): void {}

  newConversation() {
    //revisar disponibilidad
    const availabilityData = {
      PhoneNumber: this.candidateNumber,
      CdtId: this.candidate?.cdT_ID,
    };

    this.puzzleService
      .checkWhatsappAvailability(availabilityData)
      .subscribe((res: any) => {
        if (res?.isSuccess) {
          this.getTemplates();
          this.templatesActive = true;
        } else {
          // mensaje de error y cerrar modal
          this.blockedInput = true;
          this.isLoadingMoreMessages = false;
          this.translate.get('whatsappBlocked').subscribe((message: string) => {
            this.openResultDialog(0, message); // Mostrar diálogo de error
            this.dialogRef.close();
          });
        }
      });
  }

  continueConversation() {
    // se crea conexion y se recuperan mensajes
    this.getMessageList();

    //revisar disponibilidad
    const availabilityData = {
      PhoneNumber: this.candidateNumber,
      CdtId: this.candidate?.cdT_ID,
    };

    this.puzzleService
      .checkWhatsappAvailability(availabilityData)
      .subscribe((res: any) => {
        if (res?.isSuccess) {
          // se checa si ya pasaron 24 horas
          let needsTemplateMessage = false;
          if (res?.data?.needsTemplateMessage) {
            needsTemplateMessage = true;
          }

          if (!needsTemplateMessage) {
            this.createConnection();
          } else {
            this.blockedInput = true;
            this.isLoadingMoreMessages = false;
            this.templatesActive = true;
            this.getTemplates();
          }

          if (!res?.data?.canSendFreeText) {
            this.blockedInput = true;
            this.isLoadingMoreMessages = false;
            this.templatesActive = false;
            this.blockedReason = 'blockedWspWaiting';
          }
        } else {
          this.blockedInput = true;
          this.isLoadingMoreMessages = false;
          if (res?.data?.mustWaitForReply) {
            this.blockedReason = 'blockedWspWaiting';
          }
        }
      });
  }

  createConversation() {
    const data = {
      CDT_ID: this.candidate?.cdT_ID,
      COMP_ID: this.candidate?.cdT_COMPANY_ID,
      PHONE_NUMBER: this.candidateNumber,
      WHATSAPP_NUMBER_ID: this.whatsappNumberId,
    };

    this.puzzleService
      .createConversationWhatsapp(data)
      .subscribe((res: APIResponse) => {
        if (res?.isSuccess) {
          this.conversationId = res?.data?.conversationId;
          this.createConnection();
        } else {
          this.isLoadingMoreMessages = false;
        }
      });
  }

  createConnection() {
    const params = {
      WhatsappBusinessNumber: this.whatsappNumberId,
      FromNumber: this.candidateNumber,
    };

    this.puzzleService
      .createConnectionWhatsapp(params)
      .subscribe((res: any) => {
        if (res === 'Connection established successfully') {
          this.connectSocket();
        } else {
          this.isLoadingMoreMessages = false;
        }
      });
  }

  disconnectSocket() {
    const params = {
      WhatsappBusinessNumber: this.whatsappNumberId,
      FromNumber: this.candidateNumber,
    };

    this.puzzleService.disconnectWhatsapp(params).subscribe((res: any) => {});
  }

  ngOnDestroy(): void {
    // Detener todos los audios cuando se destruye el componente
    Object.values(this.audioPlayers).forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
    });

    this.disconnectSocket();

    // Disconnect socket when component is destroyed
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    const element = this.scrollContainer.nativeElement;
    // En un contenedor con flex-direction: column-reverse, el scroll funciona al revés
    // Cuando el usuario llega a la parte superior (mensajes más antiguos), scrollTop es negativo
    // y su valor absoluto se acerca al scrollHeight - clientHeight
    const isNearTop =
      Math.abs(element.scrollTop) >=
      element.scrollHeight - element.clientHeight - 5;

    if (
      isNearTop &&
      !this.isLoadingMoreMessages &&
      this.currentPage < this.totalPages
    ) {
      this.loadMoreMessages();
    }
  }

  loadMoreMessages() {
    if (this.currentPage >= this.totalPages) return;

    this.isLoadingMoreMessages = true;
    this.currentPage++;

    const timezoneOffset = -new Date().getTimezoneOffset();

    const params = {
      CONV_ID: this.conversationId,
      PageNumber: this.currentPage,
      PageSize: this.pageSize,
      UserDateTimeOffset: timezoneOffset,
    };

    this.puzzleService.getWhatsappMessages(params).subscribe((res: any) => {
      if (res?.messages?.length > 0) {
        // Guardamos la posición actual del scroll
        const previousHeight = this.scrollContainer.nativeElement.scrollHeight;
        const previousScrollPosition =
          this.scrollContainer.nativeElement.scrollTop;

        // Invertimos el orden para que los mensajes más antiguos vayan al principio del array
        // Los mensajes más recientes deben estar al final del array para mostrarse abajo
        this.messageList = [...this.messageList, ...res.messages];

        setTimeout(() => {
          // Mantenemos la posición de scroll para que el usuario no pierda su ubicación
          this.scrollContainer.nativeElement.scrollTop = previousScrollPosition;
        });
      }
      this.isLoadingMoreMessages = false;
    });
  }

  getMessageList() {
    this.isLoadingMoreMessages = true;
    const timezoneOffset = -new Date().getTimezoneOffset();

    const params = {
      CONV_ID: this.conversationId,
      PageNumber: this.currentPage,
      PageSize: this.pageSize,
      UserDateTimeOffset: timezoneOffset,
    };
    this.puzzleService.getWhatsappMessages(params).subscribe((res: any) => {
      this.messageList = res?.messages || [];

      if (this.messageList.length > 0) {
        this.updateMessageStatus(this.messageList[0].whatsapP_MESSAGE_ID);
      }

      // Store pagination information for infinite scroll
      if (res?.pagination) {
        this.totalMessages = res.pagination.totalMessages;
        this.totalPages = res.pagination.totalPages;
      }

      this.isLoadingMoreMessages = false;
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  onFileSelect(fileType: string): void {
    this.selectedFileType = fileType;
    if (fileType === 'image') {
      this.imageFileInput.nativeElement.click(); // Abre el selector de imágenes
      this.imageFileInput.nativeElement.value = null; // Limpiar el valor para permitir seleccionar la misma imagen
    } else if (fileType === 'pdf') {
      this.pdfFileInput.nativeElement.click(); // Abre el selector de PDFs
      this.pdfFileInput.nativeElement.value = null; // Limpiar el valor para permitir seleccionar el mismo PDF
    }
  }

  adjustTextareaHeight(event: any): void {
    const textarea = event.target;
    textarea.style.height = '';
    textarea.style.height = Math.min(textarea.scrollHeight, 128) + 'px';
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (this.showEmojiPicker) {
      const button = this.emojiButton?._elementRef?.nativeElement;
      const panel = this.emojiPanel?.nativeElement;
      if (button && panel) {
        const target = event.target as HTMLElement;
        const isClickInsideButton = button.contains(target);
        const isClickInsidePanel = panel.contains(target);

        if (!isClickInsideButton && !isClickInsidePanel) {
          this.showEmojiPicker = false;
        }
      }
    }
  }

  toggleEmojiPicker(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  onEmojiSelected(event: any): void {
    const textarea = document.querySelector('textarea');
    if (textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = this.message;
      const emoji = event.emoji.native;

      // Si el cursor está al final del texto, simplemente agregamos el emoji
      if (start === end && start === text.length) {
        this.message = text + emoji;
      } else {
        // Si hay texto seleccionado o el cursor está en medio del texto
        this.message = text.substring(0, start) + emoji + text.substring(end);
      }

      // Actualizar el textarea
      setTimeout(() => {
        textarea.focus();
        textarea.selectionStart = textarea.selectionEnd = start + emoji.length;
      }, 0);
    }
  }

  hideEmojiPicker(): void {
    this.showEmojiPicker = false;
  }

  openImage(imageUrl: string, fileName: string = 'Documento') {
    const imageSec = imageUrl['changingThisBreaksApplicationSecurity'];
    if (imageSec) {
      imageUrl = imageSec;
    }
    let dialog = this.dialog.open(DocuViewerComponent, {
      panelClass: 'custom-dialog-cv',
      maxWidth: '100vw',
      data: { data: imageUrl, fileName: fileName },
    });

    dialog.afterClosed().subscribe((result) => {});
  }

  openCv() {
    let dialog = this.dialog.open(DocuViewerComponent, {
      panelClass: 'custom-dialog-cv',
      data: { data: this.candidate, header: 'Curriculum vitáe' },
    });

    dialog.afterClosed().subscribe((result) => {});
  }

  closeAndNavigate() {
    this.dialog.closeAll();
  }

  getImageUrl(mediaId: string) {
    if (!mediaId) return null;
    const imageUrl =
      environment.apiWhatsAppUrl +
      '/messages/get-media?mediaId=' +
      mediaId +
      '&x-api-key=' +
      environment.whatsappApiKey2;
    return imageUrl;
  }

  isPdf(url: string) {
    return url.includes('.pdf');
  }

  openLocation(latitude: number, longitude: number) {
    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, '_blank');
  }

  getStaticMapUrl(latitude: number, longitude: number): string {
    const zoom = 15;
    const width = 250;
    const height = 150;
    return `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=${width}x${height}&maptype=roadmap&markers=color:red%7C${latitude},${longitude}&key=AIzaSyCP59wyi3P28fzDF1Eb6Ajsx9gqRNtoFPs`;
  }

  toggleAudio(mediaId: string) {
    if (!this.audioPlayers[mediaId]) {
      const audioUrl = this.getImageUrl(mediaId);
      const audio = new Audio(audioUrl);

      audio.addEventListener('timeupdate', () => {
        if (audio.duration && !isNaN(audio.duration)) {
          this.audioProgress[mediaId] =
            (audio.currentTime / audio.duration) * 100;
          this.audioCurrentTime[mediaId] = this.formatDuration(
            audio.currentTime,
          );
        }
      });

      audio.addEventListener('loadedmetadata', () => {
        if (audio.duration && !isNaN(audio.duration)) {
          this.audioDurations[mediaId] = this.formatDuration(audio.duration);
          this.audioCurrentTime[mediaId] = '0:00';
          this.audioLoaded[mediaId] = true;
        }
      });

      audio.addEventListener('ended', () => {
        this.audioProgress[mediaId] = 0;
        this.audioCurrentTime[mediaId] = '0:00';
      });

      this.audioPlayers[mediaId] = audio;
      this.audioLoaded[mediaId] = false;
    }

    const audio = this.audioPlayers[mediaId];
    if (audio.paused) {
      // Detener todos los otros audios antes de reproducir este
      Object.entries(this.audioPlayers).forEach(([id, player]) => {
        if (id !== mediaId && !player.paused) {
          player.pause();
        }
      });
      audio.play();
    } else {
      audio.pause();
    }
  }

  isPlaying(mediaId: string): boolean {
    const audio = this.audioPlayers[mediaId];
    return audio && !audio.paused;
  }

  getAudioProgress(mediaId: string): number {
    return this.audioProgress[mediaId] || 0;
  }

  getAudioDuration(mediaId: string): string {
    const audio = this.audioPlayers[mediaId];
    const currentTime = this.audioCurrentTime[mediaId] || '0:00';

    if (!this.audioLoaded[mediaId]) {
      return '0:00';
    }

    if (audio && audio.duration && !isNaN(audio.duration)) {
      return `${currentTime} / ${this.formatDuration(audio.duration)}`;
    }

    return '0:00';
  }

  formatDuration(seconds: number): string {
    if (!seconds || isNaN(seconds)) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    // checar q minutos no sea infinito
    if (minutes === Infinity || remainingSeconds === null) {
      return '0:00';
    }
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  generateWaveBars(): number[] {
    return Array(this.BAR_COUNT).fill(0);
  }

  getBarHeight(index: number, mediaId: string): number {
    const audio = this.audioPlayers[mediaId];
    const progress = this.audioProgress[mediaId] || 0;
    const isPlaying = this.isPlaying(mediaId);

    if (!audio || !isPlaying) {
      // Cuando no está reproduciendo, mostrar el patrón estático
      return this.wavePattern[index] * 0.4;
    }

    // Calcular qué parte de la onda está "activa" basado en el progreso
    const progressIndex = Math.floor((progress / 100) * this.BAR_COUNT);

    if (index <= progressIndex) {
      // Barras que ya han "sonado"
      return this.wavePattern[index];
    } else {
      // Barras que aún no "suenan"
      return this.wavePattern[index] * 0.4;
    }
  }

  onFileChange(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      const fileExtension = file.name
        .substring(file.name.lastIndexOf('.'))
        .toLowerCase();
      const fileSize = file.size;

      if (!this.permittedExtensions.includes(fileExtension)) {
        this.translate
          .get('fileTypeNotAllowed', {
            extensions: this.permittedExtensions.join(', '),
          })
          .subscribe((message: string) => {
            this.openResultDialog(0, message); // Mostrar diálogo de error
          });
        this.clearSelectedFile(); // Limpiar archivo no permitido
        return;
      }

      if (fileSize > this.maxFileSize) {
        // Si es una imagen, intentar comprimirla
        if (file.type.startsWith('image/')) {
          this.compressImage(file).then((compressedFile) => {
            if (compressedFile) {
              this.selectedFile = compressedFile;
              this.selectedFileName = compressedFile.name;
              this.selectedFileType = 'image';
              this.selectedFileUrl =
                this.sanitizer.bypassSecurityTrustResourceUrl(
                  URL.createObjectURL(compressedFile),
                ) as string;
            } else {
              this.translate
                .get('fileSizeExceeded', { maxSize: '5MB' })
                .subscribe((message: string) => {
                  this.openResultDialog(0, message);
                });
              this.clearSelectedFile();
            }
          });
        } else {
          this.translate
            .get('fileSizeExceeded', { maxSize: '5MB' })
            .subscribe((message: string) => {
              this.openResultDialog(0, message);
            });
          this.clearSelectedFile();
        }
        return;
      }

      this.selectedFile = file;
      this.selectedFileName = file.name;
      this.selectedFileType = file.type.startsWith('image') ? 'image' : 'pdf';
      this.selectedFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        URL.createObjectURL(file),
      ) as string;
    }
  }

  private compressImage(file: File): Promise<File | null> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target?.result as string;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
          let quality = 0.9;

          // Redimensionar si es necesario
          const maxDimension = 2048; // Máximo ancho o alto
          if (width > maxDimension || height > maxDimension) {
            if (width > height) {
              height = Math.round((height * maxDimension) / width);
              width = maxDimension;
            } else {
              width = Math.round((width * maxDimension) / height);
              height = maxDimension;
            }
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0, width, height);

          // Intentar comprimir con diferentes calidades hasta que el tamaño sea aceptable
          const compress = () => {
            canvas.toBlob(
              (blob) => {
                if (!blob) {
                  resolve(null);
                  return;
                }

                if (blob.size > this.maxFileSize && quality > 0.1) {
                  quality -= 0.1;
                  canvas.toBlob(
                    (newBlob) => {
                      if (newBlob) {
                        const compressedFile = new File([newBlob], file.name, {
                          type: 'image/jpeg',
                          lastModified: Date.now(),
                        });
                        resolve(compressedFile);
                      } else {
                        resolve(null);
                      }
                    },
                    'image/jpeg',
                    quality,
                  );
                } else {
                  const compressedFile = new File([blob], file.name, {
                    type: 'image/jpeg',
                    lastModified: Date.now(),
                  });
                  resolve(compressedFile);
                }
              },
              'image/jpeg',
              quality,
            );
          };

          compress();
        };
      };
    });
  }

  openResultDialog(mode: number, message?: string) {
    let data: string[] = [];
    switch (mode) {
      case 0:
        {
          data.push('Error');
          data.push(message);
          const dialogRef = this.dialog.open(ResponseDialogComponent, {
            width: '500px',
            /* height: '400px', */
            data: data,
          });
        }
        break;
      case 1:
        {
          data.push('Exito');
          data.push(message);

          const dialogRef = this.dialog.open(ResponseDialogComponent, {
            width: '500px',
            /* height: '400px', */
            data: data,
          });
        }
        break;
    }
  }

  clearSelectedFile(): void {
    this.selectedFile = null;
    this.selectedFileName = null;
    this.selectedFileType = null;
    this.selectedFileUrl = null;
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      if (event.shiftKey) {
        return;
      }
      event.preventDefault();
      this.sendMessage();
    }
  }

  removeSelectedFile(event: MouseEvent): void {
    event.stopPropagation();
    this.clearSelectedFile();
  }

  sendMessage() {
    if (this.blockedInput || this.sendingMessage) {
      return;
    }

    this.sendingMessage = true;
    // checar si hay un archivo seleccionado
    if (this.selectedFile) {
      const msgType = this.selectedFileType.includes('image')
        ? 'image'
        : 'document';

      const data = new FormData();
      data.append('file', this.selectedFile);
      data.append('type', msgType);

      // Convertir a Promise y esperar a que se complete el envío del archivo
      new Promise<void>((resolve, reject) => {
        this.puzzleService.uploadWhatsappFile(data).subscribe(
          (res: any) => {
            if (res?.isSuccess) {
              const messageData = {
                to: this.candidateNumber,
                type: msgType,
                mediaId: res.data?.id,
                filename: this.selectedFileName,
              };

              this.puzzleService.sendWhatsappMessage(messageData).subscribe(
                (msgRes: any) => {
                  // se agrega solo el mensaje a través de socket
                  resolve();
                },
                (error) => {
                  this.openResultDialog(
                    0,
                    error?.message || 'Error sending message',
                  );
                  reject(error);
                },
              );
            } else {
              this.openResultDialog(0, res?.message); // Mostrar diálogo de error
              reject(new Error(res?.message));
            }

            // limpiar el archivo seleccionado
            this.clearSelectedFile();
          },
          (error) => {
            this.openResultDialog(0, error?.message || 'Error uploading file');
            this.clearSelectedFile();
            reject(error);
          },
        );
      })
        .then(() => {
          // Solo enviar el mensaje de texto si hay uno y después de que el archivo se haya enviado
          if (this.message && this.message.trim()) {
            const textData = {
              to: this.candidateNumber,
              type: 'text',
              text: this.message,
            };

            this.puzzleService
              .sendWhatsappMessage(textData)
              .subscribe((res: any) => {
                // se agrega solo el mensaje a través de socket
                this.sendingMessage = false;
                this.message = '';
              });
          } else {
            this.sendingMessage = false;
          }
        })
        .catch(() => {
          this.sendingMessage = false;
        });
    } else if (this.message && this.message.trim()) {
      // Si no hay archivo pero hay mensaje, enviar solo el mensaje
      const data = {
        to: this.candidateNumber,
        type: 'text',
        text: this.message,
      };

      this.puzzleService.sendWhatsappMessage(data).subscribe((res: any) => {
        // se agrega solo el mensaje a través de socket
        this.sendingMessage = false;
        this.message = '';
      });
    } else {
      this.sendingMessage = false;
    }
  }

  private connectSocket(): void {
    // Check if socket is already connected to avoid multiple connections
    if (this.socket && this.socket.connected) {
      console.info('Socket already connected, skipping connection');
      return;
    } else if (this.socket && !this.socket.connected) {
      this.socket = null;
    }

    this.socket = io(environment.apiWhatsAppUrl, {
      transports: ['websocket'],
      autoConnect: true,
    });

    this.socket.on('connect', () => {
      console.info('🟢 Conectado');

      // Unirse a la conversación cuando se conecta
      this.socket.emit('joinConversation', {
        conversationId: this.whatsappNumberId + '_' + this.candidateNumber,
        businessNumber: this.whatsappNumberId,
        fromNumber: this.candidateNumber,
      });

      // Escuchar nuevos mensajes
      this.socket.on('newMessage', (msg) => {
        // si estaba bloqueado, se desbloquea
        if (this.blockedInput) {
          this.blockedInput = false;
          this.templatesActive = false;
        }
        // Parsear el mensaje al formato requerido por messageList
        const parsedMessage = {
          msG_TEXT: msg.MsgText,
          msG_TYPE: msg.MsgType.toLowerCase(),
          sender: msg.Sender,
          timestamp: new Date(msg.Timestamp),
          mediA_ID: msg.MediaId,
          whatsapP_MESSAGE_ID: msg.WhatsappMessageId,
          conversatioN_ID: msg.ConversationId,
          phonE_NUMBER: msg.PhoneNumber,
          whatsapP_NUMBER_ID: msg.WhatsappNumberId,
          latitude: msg.Latitude,
          longitude: msg.Longitude,
        };

        // checar si el mensaje es de tipo not_supported
        if (
          parsedMessage.msG_TYPE !== 'text' &&
          parsedMessage.msG_TYPE !== 'image' &&
          parsedMessage.msG_TYPE !== 'sticker' &&
          parsedMessage.msG_TYPE !== 'document' &&
          parsedMessage.msG_TYPE !== 'location' &&
          parsedMessage.msG_TYPE !== 'audio' &&
          parsedMessage.msG_TYPE !== 'video'
        ) {
          parsedMessage.msG_TYPE = 'not_supported';
        } else {
          // Agregar el nuevo mensaje al principio de la lista
          this.messageList.unshift(parsedMessage);
        }
      });

      // Escuchar mensajes de error
      this.socket.on('whatsapp_error', (msg) => {
        console.error('🔴 Mensaje de error:', msg);

        // Mostrar diálogo de error
        this.translate.get('whatsappBlocked2').subscribe((message: string) => {
          this.openResultDialog(0, message); // Mostrar diálogo de error
        });

        // Ya pasaron 24 horas, hay que enviar un template forzosamente
        this.blockedInput = true;
        this.blockedReason = 'blockedWspWaiting';
        this.templatesActive = true;
        this.isLoadingMoreMessages = false;
        this.getTemplates();
      });
    });

    this.socket.on('disconnect', () => {
      console.info('🔴 Desconectado');
      // reintentar la conexión
      this.socketTries++;
      if (this.socketTries == 1) {
        this.socket = null;
        this.createConnection();
      }
      if (this.socketTries <= 5 && !this.socket) {
        setTimeout(() => {
          this.socket = null;
          this.createConnection();
        }, 5000); // Reintenta cada 5 segundos
      }
    });
  }

  getTemplates() {
    this.puzzleService.getMessageTemplates().subscribe((res: any) => {
      if (res?.isSuccess) {
        this.blockedInput = true;
        this.templatesActive = true;
        this.messageTemplates = res?.data;
      } else {
        this.isLoadingMoreMessages = false;
      }
    });
  }

  getTemplateName(template: any) {
    const components = template?.components;
    // buscar el que tenga type BODY
    const body = components.find((component: any) => component.type === 'BODY');
    if (body) {
      const text = body?.text;
      if (text) {
        let txt = text;
        // buscar todas las variables entre {{ y }}
        const regex = /{{(.*?)}}/g;
        const matches = txt.match(regex);
        if (matches) {
          const variables = matches.map((match) =>
            match.replace(/{{|}}/g, '').trim(),
          );
          // para {{ nombre }} poner this.candidate?.cdT_NAME
          //para {{ reclutador}} poner Isai
          // para compañia {{ compañia }} poner this.candidate?.cdT_COMPANY_NAME

          const tokencito = this.localService.getJsonValue('token');

          const replacements = {
            1: this.candidate?.cdT_NAME,
            2: tokencito?.data?.fullName,
            3:
              tokencito?.data?.parentCompanyName ||
              tokencito?.data?.companyName,
          };
          // Reemplazar las variables en el texto
          for (const variable of variables) {
            const replacement = replacements[variable.trim()];
            if (replacement) {
              txt = txt.replace(`{{${variable}}}`, replacement);
            } else {
              txt = txt.replace(`{{${variable}}}`, `{{${variable}}}`);
            }
          }
          // Reemplazar el texto en el mensaje
          if (txt) {
            return txt.replace(/{{.*?}}/g, '').trim();
          }
        } else {
          // Si no hay variables, simplemente devolver el texto
          return text.trim();
        }
      }
    }
    return '';
  }

  sendTemplate(template: any) {
    if (this.sendingMessage) {
      return;
    }

    let data = [];
    const title = this.translate.instant('wspContactTemplate');
    const confirmMessage = `<div class="text-left"><div>${this.translate.instant('wspContactTemplateMessage')}</div> <br> <div class="text-secondary text-base">${this.getTemplateName(template)}</div></div>`;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: [
        title,
        confirmMessage,
        false,
        this.translate.instant('sendWspMessage'),
      ],
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.puzzleService
          .checkWhatsappAvailability({
            PhoneNumber: this.candidateNumber,
            CdtId: this.candidate?.cdT_ID,
          })
          .subscribe((res: any) => {
            if (res?.isSuccess) {
              if (!this.conversationId) {
                this.createConversation();
              } else {
                this.createConnection();
              }
              const body = template?.components.find(
                (component: any) => component.type === 'BODY',
              );
              // Parse template parameters and assign values based on parameter names
              const parsedComponents = [
                {
                  type: 'BODY',
                  parameters: [],
                },
              ];

              // Check if body has example parameters with named format
              if (body?.example?.body_text && body?.example?.body_text[0]) {
                // Map named parameters to their corresponding values
                parsedComponents[0].parameters = body.example.body_text[0].map(
                  (param: any, index: number) => {
                    let paramValue = '';

                    const tokencito = this.localService.getJsonValue('token');

                    // Assign values based on parameter index
                    if (index === 0) {
                      paramValue = this.candidate?.cdT_NAME || param.example;
                    } else if (index === 1) {
                      paramValue = tokencito?.data?.fullName || param.example;
                    } else if (index === 2) {
                      paramValue =
                        tokencito?.data?.parentCompanyName ||
                        tokencito?.data?.companyName ||
                        param.example;
                    } else {
                      // Use example value as fallback
                      paramValue = param.example;
                    }

                    return {
                      type: 'text',
                      text: paramValue,
                    };
                  },
                );
              } else if (body?.parameters) {
                // If already in the correct format, just map it
                parsedComponents[0].parameters = body.parameters.map(
                  (parameter: any) => ({
                    type: parameter.type,
                    text: parameter.text,
                  }),
                );
              }

              const apiData = {
                to: this.candidateNumber,
                templateName: template.name,
                languageCode: template.language,
                components: parsedComponents,
              };

              this.sendingMessage = true;
              this.puzzleService
                .sendWhatsappMessageTemplate(apiData)
                .subscribe((res: any) => {
                  if (res?.isSuccess) {
                    // "Timestamp": "2025-04-11T18:41:47.000Z",
                    const saveData = {
                      PhoneNumber: this.candidateNumber,
                      WhatsappNumberId: this.whatsappNumberId,
                      MsgText: this.getTemplateName(template),
                      MsgType: 'text',
                      MediaId: null,
                      Latitude: null,
                      Longitude: null,
                      Sender: 'company',
                      CurrentUserSession: 'TEMPLATE',
                      WhatsappMessageId: res?.data?.messages[0]?.id,
                      Timestamp: new Date().toISOString(),
                      ConversationId: this.conversationId,
                    };

                    /* Guardar template en base de datos */
                    this.puzzleService
                      .saveWhatsappMessageTemplate(saveData)
                      .subscribe((res: any) => {
                        let tries = 0;
                        const maxTries = 5;

                        //intentar 5 veces hasta que haya conversationId cada 2 segundos
                        const checkConversation = async () => {
                          do {
                            await new Promise((resolve) =>
                              setTimeout(resolve, 2000),
                            );
                            this.getMessageList();
                            tries++;
                          } while (tries < maxTries && !this.conversationId);
                        };

                        checkConversation();

                        // se quitan los templates activos
                        this.templatesActive = false;
                        this.blockedReason = 'blockedWspWaiting';
                      });
                  }

                  this.sendingMessage = false;
                });
            } else {
              // mensaje de error y cerrar modal
              this.templatesActive = false;
              this.blockedInput = true;
              this.isLoadingMoreMessages = false;
              this.translate
                .get('whatsappBlocked')
                .subscribe((message: string) => {
                  this.openResultDialog(0, message); // Mostrar diálogo de error
                  this.dialogRef.close();
                });
            }
          });
      }
    });
  }

  inyectUrlLinks(text: string) {
    // Usar una expresión regular para detectar si el mensaje contiene caracteres no-espacio o emojis
    if (!text || !text.match(/[^\s]|[\u{1F300}-\u{1F9FF}]/u)) return text;

    // Expresión regular simplificada que se enfoca en detectar texto que contiene un punto
    // y una extensión de dominio válida (al menos 2 caracteres)
    // Esto capturará dominios como linkedin.com, google.com, etc.
    const urlRegex =
      /(https?:\/\/|www\.)[^\s]+|[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})?[^\s]*/g;

    return text.replace(urlRegex, (url) => {
      // Asegurarse de que la URL tenga el protocolo correcto para el atributo href
      const href = url.startsWith('http')
        ? url
        : url.startsWith('www.')
          ? `http://${url}`
          : `http://${url}`;

      return `<a href="${href}" target="_blank" class="link-text whitespace-pre-wrap break-all break-words">${url}</a>`;
    });
  }

  updateMessageStatus(messageId: string) {
    this.puzzleService
      .updateWhatsappMessageStatus({
        WhatsappMessageId: messageId,
        Status: 'READ',
      })
      .subscribe((res: any) => {});
  }

  getDocumentName(text: string) {
    // parsear docName:"Maria de lourdes.xlsx" text:"dfgdfgfd"
    const regex = /docName:"(.*?)"/;
    const match = text.match(regex);
    if (match) {
      return match[1];
    }
    return null;
  }

  getDocumentText(text: string) {
    // parsear docName:"Maria de lourdes.xlsx" text:"dfgdfgfd"
    const regex = /text:"(.*?)"/;
    const match = text.match(regex);
    if (match) {
      return match[1];
    }
    return null;
  }

  viewWspChatHistory() {
    this.templatesActive = false;
    this.showChatHistory = true;
  }

  hideWspChatHistory() {
    this.templatesActive = true;
    this.showChatHistory = false;
  }

  getPermission(permission: string | string[]): boolean {
    if (typeof permission === 'string') {
      return this.userPermissions.includes(permission);
    } else {
      for (let i = 0; i < permission.length; i++) {
        if (this.userPermissions.includes(permission[i])) {
          return true;
        }
      }
    }
  }

  opendoc(candidate: Candidate, option?: number, index?: number) {
    if (candidate != null) {
      let routeAux = candidate.cv?.cdoC_DOCUMENT_ROUTE;
      let element1 = candidate.cv?.cdoC_DOCUMENT_ROUTE;
      let element2 = candidate.candidateCVClient?.clienT_CDOC_DOCUMENT_ROUTE;
      const element3 =
        candidate.candidateReportDocument?.reporT_CDOC_DOCUMENT_ROUTE;

      if (this.getPermission('X01') && this.showCVClient) {
        element1 = null;
      } else if (!this.showCVClient) {
        element2 = null;
      }

      let nameList = [];

      if (index == 0 && element1) {
        routeAux = element1;
      } else if (index == 1 && element2) {
        routeAux = element2;
      } else if (index == 2 && element3) {
        routeAux = element3;
      }

      const list = [element1, element2, element3].filter((x) => x != null);

      if (element1)
        nameList.push(
          this.translate.instant('CV') + ' - ' + candidate.cdT_NAME,
        );
      if (element2) {
        if (this.getPermission('X01') && this.showCVClient) {
          nameList.push(
            this.translate.instant('CV') + ' - ' + candidate.cdT_NAME,
          );
        } else {
          nameList.push(
            this.translate.instant('CV_CLIENTS') + ' - ' + candidate.cdT_NAME,
          );
        }
      }
      if (element3)
        nameList.push(
          this.translate.instant('CANDIDATE_REPORT') +
            ' - ' +
            candidate.cdT_NAME,
        );

      index = list.findIndex((x) => x == routeAux);

      let dataToSend = {
        data: routeAux,
        header: 'Curriculum vitáe',
        list: list,
        index: index,
        nameList: nameList,
      };

      let dialog = this.dialog.open(DocuViewerComponent, {
        panelClass: 'custom-dialog-cv',
        maxWidth: '100vw',
        data: dataToSend,
      });

      dialog.afterClosed().subscribe((result) => {});
    }
  }

  openUploadCV(candidate: Candidate, fileName: string) {
      const dialogRef = this.dialog.open(UploadCvComponent, {
        data: {
          candidate: candidate,
          fileName: fileName,
        },
      });
  
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.dialogRef.close();
        }
      });
    }
}
